"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _OverviewRow = _interopRequireDefault(require("../OverviewRow"));
var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1zm0 6.014a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.276 3.959c.773-1.315 2.675-1.315 3.448 0l8.251 14.027C22.76 19.32 21.798 21 20.252 21H3.748c-1.546 0-2.508-1.68-1.723-3.014L10.276 3.96zM12 4.973 3.748 19h16.504L12 4.973z"
  }));
};
WarningIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "icon": "icon_1_YZ3A"
}; 
require('./OverviewStatus.css');
var OverviewStatus = function OverviewStatus(_ref) {
  var asset = _ref.asset;
  if (asset.status === 'deprecated') {
    return /*#__PURE__*/_react.default.createElement(_OverviewRow.default, {
      title: "Status",
      testId: "asset-status"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: styles.icon,
      size: "s",
      isDecorative: true
    }, /*#__PURE__*/_react.default.createElement(WarningIcon, null)), "Deprecated");
  }
  return null;
};
var _default = exports.default = OverviewStatus;
//# sourceMappingURL=OverviewStatus.js.map